import { createAction } from "@reduxjs/toolkit";

import { FEATURE_NAME, withNamespace } from "../constants/namespace";

export const initialize = createAction(withNamespace("initialize"));

export const sendClickToSellHomepageEvent = data => (
  _dispatch,
  _getState,
  extra
) =>
  extra[FEATURE_NAME].analyticsService.sendClickToSellHomepageEvent({
    expertContactId: data.expertContactId,
    propertyId: data.propertyId,
    uuid: data.uuid
  });
